import axios, {AxiosError, AxiosRequestConfig, InternalAxiosRequestConfig} from "axios";
import CONFIG from "./config";
import qs from 'qs';
import { DefaultApi } from "@/generated/openapi/api";
import AuthService, {TokenStorage} from "@/services/authService";
import router from "./routesWidgetAccount";
import { RouteLocationRaw, RouteRecordRaw } from "vue-router";

declare module 'axios' {
  export interface AxiosRequestConfig {
    _retry?: boolean;
  }
}

// Define the base options with types
const baseOptions: AxiosRequestConfig = {
  baseURL: CONFIG.baseApiUrl,
  paramsSerializer: (params: any): string => {
    console.debug('serializing', params);
    return qs.stringify(params, { indices: false, skipNulls: true });
  },
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  }
};

// Create a standard Axios client with the base options
const httpClient = axios.create(baseOptions);

// Add a response interceptor
/* httpClient.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    const status = error.response.status;
    console.log(status);
    if (status === 401) {
      // 'Unauthorized access!'
    } else if (status === 500) {
      // 'Server error!'
    }
  }
  return Promise.reject(error);
}); */

const defaultApi = new DefaultApi(undefined, '', httpClient);

// Create a public Axios client with the base options
const publicApiClient = axios.create(baseOptions);

publicApiClient.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  const tokenString = sessionStorage.getItem('token');
  if (tokenString) {
    // const token: TokenStorage = JSON.parse(tokenString);

    // try {
    //   await AuthService.refreshAccessToken(token.refreshToken);
    // } catch (error) {
    //   sessionStorage.removeItem('token');
    //   sessionStorage.removeItem('user');
    //   router.push({ name: 'login' } as RouteRecordRaw);
    //   console.error('Token refresh failed, redirecting to login:', error);
    //   return Promise.reject(error);
    // }


    // const newTokenString = sessionStorage.getItem('token');

    // if(!newTokenString) {
    //   return config;
    // }

    const newToken: TokenStorage = JSON.parse(tokenString);

    // if (newToken && newToken.accessToken && new Date().getTime() < newToken.expires) {
    if (newToken && newToken.accessToken) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${newToken.accessToken}`;
    } else {
      console.log("expired");
    }
  }
  return config;
});

// publicApiClient.interceptors.response.use((response) => {
//   return response;
// }, async (error: AxiosError) => {
//   const originalRequest = error.config;
//   if (error.response?.status === 401 || error.response?.status === 500 && originalRequest !== undefined && !originalRequest._retry) {
//     (originalRequest as InternalAxiosRequestConfig)._retry = true;
//     try {
//       const tokenString = sessionStorage.getItem('token');
//       if (!tokenString) throw new Error('No token available');

//       const token: TokenStorage = JSON.parse(tokenString);

//       let newAccessToken = undefined;

//       try {
//         newAccessToken = await AuthService.refreshAccessToken(token.refreshToken);
//       } catch (error) {
//         sessionStorage.removeItem('token');
//         sessionStorage.removeItem('user');
//         router.push({ name: 'login' } as RouteRecordRaw);
//         console.error('Token refresh failed, redirecting to login:', error);
//         return Promise.reject(error);
//       }

//       console.log("newAccessToken");
//       axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
//       return publicApiClient(originalRequest as InternalAxiosRequestConfig);
//     } catch (refreshError) {
//       console.error('Refresh Token Error:', refreshError);
//       throw refreshError;
//     }
//   }
//   return Promise.reject(error);
// });

// Create a public API (websites) instance with the custom Axios client
const publicApi = new DefaultApi(undefined, '', publicApiClient);

export {
  baseOptions,
  httpClient,
  defaultApi,
  publicApi
};
